/**
 * API_BASE Configuration
 * Version: 3.1 (FORCED ABSOLUTE)
 */

const normalizeUrl = (url: string | undefined): string => {
  if (!url || typeof url !== 'string' || url === 'undefined') {
    return '';
  }

  let trimmed = url.trim();

  // If it's already an absolute URL, just return it
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed.replace(/\/$/, '');
  }

  // IF NO PROTOCOL, WE MUST ADD ONE or it will be a relative path error
  console.warn('⚠️ [apiBase] URL missing protocol, FORCING https:// prefix on:', trimmed);
  return `https://${trimmed}`.replace(/\/$/, '');
};

const getApiBase = (): string => {
  // Use Vite's environment variable loading
  const env = (import.meta as any).env;

  // DEBUG LOGS (Watch these in browser F12 console)
  console.log('� [apiBase v3.1] Raw Env Check:', {
    VITE_API_BASE_URL: env?.VITE_API_BASE_URL,
    VITE_API_URL: env?.VITE_API_URL,
    MODE: env?.MODE,
    HOSTNAME: typeof window !== 'undefined' ? window.location.hostname : 'ssr'
  });

  const rawUrl = env?.VITE_API_BASE_URL || env?.VITE_API_URL;

  // 1. If we have an env var, normalize and use it
  if (rawUrl && rawUrl !== 'undefined') {
    const normalized = normalizeUrl(rawUrl);
    console.log('✅ [apiBase v3.1] Using URL from Environment:', normalized);
    return normalized;
  }

  // 2. Development Case (Localhost)
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    console.log('✅ [apiBase v3.1] Localhost detected, using port 3001');
    return 'http://localhost:3001';
  }

  // 3. Production default: the static frontend and API are separate Render
  // services. Never fall back to the frontend origin, because that makes
  // `/api/*` requests hit the static site instead of the Express service.
  if (typeof window !== 'undefined') {
    return 'https://api.catalogmuse.com';
  }

  return '';
};

export const API_BASE = getApiBase();

// CRITICAL SAFETY CHECK
if (typeof window !== 'undefined') {
  if (API_BASE && !API_BASE.startsWith('http')) {
    console.error('😱 [apiBase v3.1] FATAL ERROR: API_BASE IS RELATIVE! THIS CAUSES 404s!');
  }
}
